
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile",
      function () {
        return require("private-next-pages/mobile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile"])
      });
    }
  